import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { environment } from 'src/environments/environment';
import { Pageable } from 'src/app/pageable';
import { Observable } from 'rxjs';
import { Page } from 'src/app/page';

@Injectable({
  providedIn: 'root'
})
export class ServiceProvidersService {

  constructor(private httpClient: HttpClient, private app: AppService) { }

  getServiceProvidersFilteredPage(pageable: Pageable, filterValue: string, nextPage?: boolean): Observable<Page<any>> {
      const headers = new HttpHeaders({
        'Content-type': 'application/json'
      });
  
      let nextPagePar = false;
      if (nextPage !== null && nextPage !== undefined) {
        nextPagePar = true;
      }
  
      return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.findAllServiceProviders + '?pageNumber=' + pageable.pageNumber
        + '&pageSize=' + pageable.pageSize + '&nextPage=' + nextPagePar,
        JSON.parse(JSON.stringify(filterValue)), { headers }) as Observable<any>;
  
  }

  getAllServiceProviders() {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
   });
   return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.findAllServiceProviders, { headers }) as Observable<any>;
  }

  createServiceProvider(serviceProvider: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    return this.httpClient.post(this.app.getServiceProvidersUrl() + environment.createServiceProvider, serviceProvider, { headers }) as Observable<any>;
  }

  updateServiceProvider(serviceProvider: any, serviceProviderId: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json'
    });
    return this.httpClient.put(this.app.getServiceProvidersUrl() + environment.updateServiceProvider + serviceProviderId, serviceProvider, { headers }) as Observable<any>;
  }

  findById(id: any) {
    const headers = new HttpHeaders({
       'Content-type': 'application/json',
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.findServiceProviderById + id, { headers }) as Observable<any>;
  }

  getServiceProviderUserRoles() {
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
    });
    return this.httpClient.get(this.app.getUrl() + environment.getServiceProviderUserRoles, { headers }) as Observable<any>;
  }

  findProvidedServicesByServiceProviderId(serviceProviderId: any) {
    const headers = new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
    });
    return this.httpClient.get(this.app.getServiceProvidersUrl() + environment.getProvidedServicesByServiceProviderId + serviceProviderId, { headers }) as Observable<any>;
  }

  getSignatoriesUsersInServiceProvider(serviceProviderId: any) {
    return this.httpClient.get(this.app.getUrl() + environment.findServiceProviderSignatoriesUsers + serviceProviderId) as Observable<any>;
  }

  getUsersByServiceProviderId(serviceProviderId: any) {
    return this.httpClient.get(this.app.getUrl() + environment.findAllUsersByServiceProviderIdUrl + serviceProviderId) as Observable<any>;
  }
}
